import { AuthAlgoEntities } from "@/domain/entities/AuthAlgo";
import { AxiosResponse } from "axios";

export class AuthAlgoMapper {
  public convertAuthDataFromApi(result: AxiosResponse<any>): AuthAlgoEntities {
    const { data } = result;
    return new AuthAlgoEntities(data.token, data.type, data.expired_at);
  }
}
